import { Box, SxProps } from '@mui/system';

interface Props {
  srcSet: string;
  alt: string;
  sx?: SxProps;
}

const Picture: React.FC<Props> = ({ srcSet, alt, sx }) => {
  return (
    <Box sx={{ ...sx }}>
      <picture style={{ display: 'block', width: 'fit-content' }}>
        <source srcSet={srcSet} />
        <img src={srcSet} alt={alt} />
      </picture>
    </Box>
  );
};

export default Picture;
